import React from 'react';

interface GlassInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // extends native input props
}

export const GlassInput = React.forwardRef<HTMLInputElement, GlassInputProps>(
  (props, ref) => {
    const { className = '', style, ...rest } = props;
    return (
      <>
        <style>{`
          .glass-input::placeholder {
            color: rgba(255, 255, 255, 0.35);
          }
        `}</style>
        <input
          ref={ref}
          className={`glass-input w-full rounded-xl px-5 py-4 text-white outline-none transition-all duration-200 ${className}`}
          style={{
            background: 'rgba(255, 255, 255, 0.06)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            fontSize: '16px',
            ...style,
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
            props.onFocus?.(e);
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
            props.onBlur?.(e);
          }}
          {...rest}
        />
      </>
    );
  }
);

GlassInput.displayName = 'GlassInput';
